var INFO_EVENTS = {
    CUSTOM_BUTTON_CLICKED: 'CUSTOM_BUTTON_CLICKED',
    SOCIAL_SHARE_BUTTON_CLICKED: 'SOCIAL_SHARE_BUTTON_CLICKED',
    SHARE_BUTTON_CLICKED: 'SHARE_BUTTON_CLICKED',
    TEXT_DOWNLOAD_BUTTON_CLICKED: 'TEXT_DOWNLOAD_BUTTON_CLICKED',
    LOVE_BUTTON_CLICKED: 'LOVE_BUTTON_CLICKED',
    DOWNLOAD_BUTTON_CLICKED: 'DOWNLOAD_BUTTON_CLICKED',
};
export default INFO_EVENTS;
//# sourceMappingURL=infoEvents.js.map